import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { IButtonGroupProps } from '../ButtonGroup'

import {
  DetailsSecondaryOpacityButton,
  PlayPrimaryButton,
} from 'atoms/Button/Templates'
import { ButtonGroup } from '../ButtonGroup'

export interface IButtonGroupTemplate3Props extends Omit<
  IButtonGroupProps,
  'children'
> {
  list: [IButtonProps['title'], IButtonProps['title']]
}

export const ButtonGroupTemplate3 = ({
  list,
  ...rest
}: IButtonGroupTemplate3Props): JSX.Element => (
  <ButtonGroup {...rest}>
    <PlayPrimaryButton title={list?.[0] || ''} />
    <DetailsSecondaryOpacityButton title={list?.[1] || ''} />
  </ButtonGroup>
)
